<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.tool_pricing && source">
  <app-popup-header *ngIf="isEditMode" title="{{localService.languageContent.tool_pricing.header}}"></app-popup-header>
  <div [ngClass]="isEditMode ? 'modal-body' : 'center'" *ngIf="items"
    [ngStyle]="{'max-height' : isEditMode ? maxBodyHeight + 'px' : 'auto', 'max-width' : isEditMode ? 'auto' : '900px'}">
    <div style="display:none;">
      <i class="material-icons on_language_changed" (click)="onLoad(true)">refresh</i>
    </div>
    <div *ngIf="!isEditMode" class="row">
      <ngx-select style="max-width:300px;" *ngIf="localService.countryCodes" [(ngModel)]="ctryId"
        [optionValueField]="'key'" [optionTextField]="'v1'" [items]="localService.countryCodes" (select)="onLoad()"
        [noAutoComplete]="true" [disabled]="ctryId != '' && localService.countryCodes.length == 1">
      </ngx-select>
    </div>
    <div *ngIf="items.length == 0" class="row">
      <div class="col-md-12" style="text-align:center;margin-top:10%">
        <div style="font-size: 25px;">{{localService.languageContent.common.no_data}}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="text-align: right;color: indianred;">
        {{localService.languageContent.tool_pricing.message}}
      </div>
    </div>
    <div class="row line" [ngClass]="item.key == '-' ? '' : 'styled_row'" *ngFor="let item of items">
      <div class="col-9">
        <div *ngIf="item.key == '-'" style="margin-top:20px;">
          <label>{{localService.getText(source.chargeMethod,item.v1)}}</label>
        </div>
        <div style="margin-left:5px;" *ngIf="item.key != '-'">
          <label style="font-weight: normal; margin-left: 30px;" *ngIf="isEditMode">
            <input type="checkbox" [(ngModel)]="item.isReadonly" />
            <span class="normal_color">{{localService.getText(item.v1 == '1' ? source.toolPricingType :
              source.notificationType,item.v2)}}</span>
          </label>
          <label style="font-weight:normal" *ngIf="!isEditMode">{{localService.getText(item.v1 == '1' ?
            source.toolPricingType : source.notificationType,item.v2)}}</label>
        </div>
      </div>
      <div class="col-3">
        <div *ngIf="item.key == '-'" style="margin-top:20px;">
          &nbsp;
        </div>
        <div style="text-align:right;" *ngIf="item.key != '-'">
          <input autocomplete="off" *ngIf="isEditMode" type="number" class="number"
            (keypress)="localService.isNumberOnly($event,numericConfig)" [ngClass]="item.value ? 'en' : ''"
            [(ngModel)]="item.value" placeholder="{{localService.languageContent.tool_pricing.cost}}"
            title="{{localService.languageContent.tool_pricing.cost}}" />
          <span class="en" *ngIf="!isEditMode"
            [innerHTML]="'&nbsp;' + localService.getCurencyCode(ctryCode) + ' ' + (item.value | number:'1.2-2')">
          </span>
          <span class="en" *ngIf="!isEditMode">&nbsp;/&nbsp;{{item.v1 == '1' ? 'Month' : 'Unit'}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" *ngIf="isEditMode">
    <button type="button" class="btn btn-primary"
      (click)="onSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>